import React, { useEffect } from 'react';

const getStyles = (theme, type) => {
    const isDark = theme === 'dark';
    const colors = {
        success: { bg: isDark ? '#2e7d32' : '#d4edda', text: isDark ? '#e8f5e9' : '#155724', border: isDark ? '#388e3c' : '#c3e6cb' },
        error: { bg: isDark ? '#d32f2f' : '#f8d7da', text: isDark ? '#fdecea' : '#721c24', border: isDark ? '#f44336' : '#f5c6cb' },
    };
    const selected = colors[type] || colors.error;

    return {
        alert: {
            position: 'fixed',
            top: '20px',
            right: '20px',
            padding: '15px 20px',
            borderRadius: '8px',
            backgroundColor: selected.bg,
            color: selected.text,
            border: `1px solid ${selected.border}`,
            zIndex: 2000,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            minWidth: '300px',
        },
        closeButton: {
            marginLeft: '15px',
            background: 'none',
            border: 'none',
            fontSize: '20px',
            color: selected.text,
            cursor: 'pointer',
        }
    };
};

function CustomAlert({ show, message, type = 'success', onClose, theme }) {
    const styles = getStyles(theme, type);

    useEffect(() => {
        if (show) {
            const timer = setTimeout(() => {
                onClose();
            }, 5000); // Auto-close after 5 seconds
            return () => clearTimeout(timer);
        }
    }, [show, onClose]);

    if (!show) {
        return null;
    }

    return (
        <div style={styles.alert}>
            <span>{message}</span>
            <button onClick={onClose} style={styles.closeButton}>&times;</button>
        </div>
    );
}

export default CustomAlert;
